
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D80027","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M196.641 85.337v341.326H0V85.337z"}}),_c('circle',{attrs:{"fill":"#FFDA44","cx":"196.641","cy":"256","r":"64"}}),_c('path',{attrs:{"fill":"#D80027","d":"M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"}})])
          )
        }
      }
    